import { addSeconds, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

/**
 * Adds seconds to an ISO 8601 formatted string and returns the new date as a string.
 * @param timeString - The ISO 8601 formatted date string.
 * @param seconds - The number of seconds to add.
 * @param timezone - The timezone to format the new date in.
 * @returns The new date as an ISO 8601 formatted string.
 */
export const addSecondsToISOString = (timeString: string, seconds: number, timezone: string) => {
  const newDate = addSeconds(parseISO(timeString), seconds);
  return formatInTimeZone(newDate, timezone, "yyyy-MM-dd'T'HH:mm:ss.sssXXX");
};
